import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        webHost: 'http://web.shankm.xyz/',
        webHostCdn: 'http://cdn.th.shankmgame.xyz/',

        webHostDev: 'http://shankmdev.petaplay.com/',
        webHostCdnDev: 'http://shankmcdndev.petaplay.com/',

        // packageList: [
        //     {
        //         packageName: "com.joyours.shankm.official",
        //         icon: require("src/assets/icon.png"),
        //         mobileIcon: "",
        //         apkUrl: "",
        //         iosUrl: "",
        //         updateTime: "",
        //         desc: "",
        //         version: ""
        //     }
        // ],
        fanPageUrl: "https://www.facebook.com/shankoemeeboogyi/",
        payShopUrl: "https://www.codashop.com/mm/shan-koe-mee",
        newTitle: "သတင္းသစ္",
        newList: [
            {
                type: "အေၾကာင္း",
                title: "ဖဲဂိမ္းအေၾကာင္း",
                url: "/new1",
                name: "new1",
                time: "08/10/2019"
            },
            {
                type: "သတင္း",
                title: "ဂိမ္းဗားရွင္းသစ္သတင္း ",
                url: "/new2",
                name: "new2",
                time: "08/10/2019"
            }
        ]
    },
    actions: {
        // getConf(context) {
        //     axios.get('http://web.shankm.xyz/offcial/getConf', {
        //         params: {
        //             game: 'shankm',
        //             num: '995192594',
        //             sig: 'fa3e51df37ab908b08bfc1853ee4c289',
        //         }
        //     })
        //         .then(function (response) {
        //             if (0 == response.data.ret) {
        //                 context.commit('updatePackageList', response.data.info)
        //                 context.commit('updateOther', response.data)
        //             }
        //         })
        //         .catch(function (error) {
        //         });
        // }
    },
    mutations: {
        // updatePackageList(state, payload) {
        //     for (const i in state.packageList) {
        //         let one = state.packageList[i]
        //         if (payload[one.packageName]) {

        //             const oneConf = payload[one.packageName]
        //             for (const key in oneConf) {
        //                 one[key] = oneConf[key]
        //             }
        //         }
        //     }
        // },
        // updateOther(state, payload) {
        //     state.fanPageUrl = payload.fanPageUrl
        //     state.payShopUrl = payload.payShopUrl
        // }
    },
    getters: {}
})
export default store